import React from 'react'
import BasicLayout from './layouts/basic_layout'
import Routes from './config/routes';
import { connect } from 'react-redux';
import { BrowserRouter} from 'react-router-dom'

class RootContainer extends React.Component{
  constructor(props) {
    super(props);

    this.state = {loaded: false}
  }

  componentWillReceiveProps(nextProps) {
    this.setState({loaded: nextProps.app_state.loaded});
  }

  render() {
    if (this.state.loaded) {
      return (
        <BrowserRouter>
          <BasicLayout>
            <Routes />
          </BasicLayout>
        </BrowserRouter>
      );
    } else {
      return (
        <div>Loading</div>
      );
    }
  }
}

const mapStateToProps = (state) => {
  return {
    app_state: state.applicationState
  }
};

export default connect(mapStateToProps, null, null, {pure: false})(RootContainer);


// WEBPACK FOOTER //
// ./app/javascript/app/root.jsx